<template>
  <div>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllPoints"></b-form-checkbox>
        <span @click="checkedAllPoints = !checkedAllPoints">OpenStreetMap points</span>
        <div style="float: right;">
          <img @click="expanded = !expanded" style="height: 13px; cursor: pointer;" :src="expanded ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expanded">
        <b-form-checkbox class="display-inline marginright5" v-model="active"></b-form-checkbox>
        <span @click="active = !active">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="inactive"></b-form-checkbox>
        <span @click="inactive = !inactive">Inactive</span>
      </div>
    </div>    
    <MapPlace v-for="place of $store.state.maplasPlaces[$DataOrigin.openstreetmap]" :key="place.id" :place="place"></MapPlace>
    <br>
    <div class="card">
      <div class="card-header py-2">
        <Spinner v-if="loading" margin_right="10px" height="20px" />
        <b-form-checkbox v-else class="display-inline marginright5" v-model="checkedAllCycleWays"></b-form-checkbox>
        <span @click="checkedAllCycleWays = !checkedAllCycleWays">OpenStreetMap cycleways</span>
        <div style="float: right;">
          <img @click="expandedCyclewyas = !expandedCyclewyas" style="height: 13px; cursor: pointer;" :src="expandedCyclewyas ? icons.chevronUp : icons.chevronDown" />
        </div>
      </div>
      <div class="card-body" v-if="expandedCyclewyas">
        <b-form-checkbox class="display-inline marginright5" v-model="cyclewaysActive">
        </b-form-checkbox>
        <span @click="cyclewaysActive = !cyclewaysActive">Active</span>
        <b-form-checkbox class="display-inline marginright5" v-model="cyclewaysInactive">
        </b-form-checkbox>
        <span @click="cyclewaysInactive = !cyclewaysInactive">Inactive</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import BaseComponent from './Base.vue';
import { EventBus } from '@/ts/EventBus';
import Place from '@/ts/Place';
import PlaceType from '@/ts/PlaceType';
import { AlertStatus, DataOrigin, DownloadStatus } from '@/ts/types';
import { defineComponent } from "vue";
import { log as debugLog } from '@/ts/debug';

export default defineComponent({
    extends: BaseComponent,
    data() {
        const checkedAllCycleWays: boolean = false;
        const checkedAllPoints: boolean = false;

        return {
            checkedAllPoints,
            expanded: false,
            active: true,
            inactive: false,
            checkedAllCycleWays,
            expandedCyclewyas: false,
            cyclewaysActive: true,
            cyclewaysInactive: false,
            loading: false
        };
    },
    created() {
      EventBus.$on('downloadExternalData', () => this.downloadPlacesOpenStreetMap());
      EventBus.$on('toggleOSMPoints', () => {
        if (this.$options.result) {
          this.checkedAllPoints = !this.checkedAllPoints;
        }
      });
      EventBus.$on('toggleOSMCycleways', () => {
        if (this.$options.result) {
          this.checkedAllCycleWays = !this.checkedAllCycleWays;
        }
      });
      EventBus.$on('selectedAreaChanged', (newArea: string, oldArea: string) => this.onSelectedAreaChanged(newArea, oldArea));
    },
    methods: {

      isPointInSelectedArea(lat: number | string, lon: number | string) {
        // @ts-ignore
        const areaKey = window.selectedArea;
        if (!areaKey) return true;
        // @ts-ignore
        const area = window.areas[areaKey];
        if (!area || !area[0] || !area[1]) return true;
        const minLat = Math.min(area[0][0], area[1][0]);
        const maxLat = Math.max(area[0][0], area[1][0]);
        const minLon = Math.min(area[0][1], area[1][1]);
        const maxLon = Math.max(area[0][1], area[1][1]);
        const plat = Number(lat);
        const plon = Number(lon);
        if (Number.isNaN(plat) || Number.isNaN(plon)) return false;
        return (plat >= minLat && plat <= maxLat && plon >= minLon && plon <= maxLon);
      },

      isPathInSelectedArea(path: any[]) {
        if (!path || !path.length) return false;
        for (const p of path) {
          if (Array.isArray(p) && p.length >= 2) {
            if (this.isPointInSelectedArea(p[0], p[1]) || this.isPointInSelectedArea(p[1], p[0])) return true;
          } else if (p && typeof p === 'object') {
            const lat = p.lat ?? p.latitude ?? p[0];
            const lon = p.lon ?? p.lng ?? p.longitude ?? p[1];
            if (lat !== undefined && lon !== undefined && this.isPointInSelectedArea(lat, lon)) return true;
          }
        }
        return false;
      },

      onSelectedAreaChanged(newArea: string, oldArea: string) {
        // remove existing markers and cycleways
        if (this.$options.places) {
          for (const place of this.$options.places) {
            try { place.getMarker().removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.cycleways) {
          for (const cycleway of this.$options.cycleways) {
            try { cycleway.removeFrom(window.mainmap); } catch (e) {}
          }
        }
        if (this.$options.result) {
          this.processPlacesOpenStreetMap();
        }
      },
        downloadPlacesOpenStreetMap() {
            this.loading = true;
            const endPoint = window.apiHost + 'api/stringfield/openstreetmap/';
            this.downloadUrlWithCache(endPoint, 'openstreetmap', 'openstreetmap.txt', null, true).then((response) => {
              this.$options.result = response[1].results;
              if (response[0] == DownloadStatus.cache_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.api_fresh) {
                this.createAlert(AlertStatus.success, this.$t('placesDownloaded', [response[1].results.length]).toString(), 2000);
              }
              if (response[0] == DownloadStatus.cache_last) {
                this.createAlert(AlertStatus.warning, this.$t('placesLoaded', [response[1].results.length]).toString(), 2000);
              }
            }).catch((error) => {
              this.createAlert(AlertStatus.danger, this.$t('placesError').toString(), 2000);
            }).finally(() => {
              this.loading = false;
            })
        },
        processPlacesOpenStreetMap() {
            const ms_start = Date.now()
            const places: Place[] = [];
            const cycleways: any[] = [];
            const parking_type = new PlaceType(1000000, 'parking', {'color': 'rgb(38, 120, 252)'}, 1);
            const bicycle_parking_type = new PlaceType(1000000, 'parking', {'color': 'rgb(114, 128, 219)'}, 1);
            const shelter_type = new PlaceType(1000001, 'other', {'color': 'brown'}, 1);
            const other_type = new PlaceType(1000002, 'other', {'color': 'orange'}, 1);
            const picnic_site_type = new PlaceType(1000002, 'other', {'color': 'green'}, 1);
            const picnic_table_type = new PlaceType(1000002, 'other', {'color': 'rgb(16, 194, 63)'}, 1);
            const viewpoint_type = new PlaceType(1000002, 'other', {'color': 'rgb(227, 64, 205)'}, 1);
            const bicyle_type = new PlaceType(1000002, 'other', {'color': 'red'}, 1);
            for (const responsePlace of this.$options.result) {
              let placetype = other_type;
              let name = 'Other';
              if (responsePlace.type == 'parking') {
                placetype = parking_type;
                name = 'Parking';
              }
              else if (responsePlace.type == 'shelter') {
                placetype = shelter_type;
                name = 'Wiata';
              }
              else if (responsePlace.type == 'bicycle_parking') {
                placetype = bicycle_parking_type;
                name = 'Parking rowerowy';
              }
              else if (responsePlace.type == 'picnic_site') {
                placetype = picnic_site_type;
                name = 'Piknik';
              }
              else if (responsePlace.type == 'picnic_table') {
                placetype = picnic_table_type;
                name = 'Stół';
              }
              else if (responsePlace.type == 'viewpoint') {
                placetype = viewpoint_type;
                name = 'Widok';
              }
              else if (responsePlace.type == 'cycle_way') {
                placetype = bicyle_type;
                name = 'Rower';
              }
              if (responsePlace.fronttype == 'node') {
                const desc = responsePlace.tags.name;
                const place = new Place(responsePlace.id, name, desc, responsePlace.lat, responsePlace.lon, placetype, false, null, DataOrigin.openstreetmap, responsePlace.is_active);
                place.createMarker();
                if (this.isPointInSelectedArea(place.lat, place.lon)) {
                  places.push(place);
                }
              } else {
                const cycleway = new L.Polyline(responsePlace.path, {
                  color: 'red',
                  weight: 5,
                  opacity: 1,
                  smoothFactor: 1,
                });
                cycleway.is_active = responsePlace.is_active;
                if (this.isPathInSelectedArea(responsePlace.path)) {
                  cycleways.push(cycleway);
                }
              }
            }
            const ms_end = Date.now()
            debugLog(ms_end - ms_start);
            this.$options.places = places;
            this.$options.cycleways = cycleways;
            this.onCheckedAllChanged();
            this.onCheckedAllCyclewaysChanged();
        },
        onCheckedAllChanged() {
            if (this.$options.places) {
              for(const place of this.$options.places) {
                if (this.checkedAllPoints) {
                  if (place.is_active) {
                    if (this.active) {
                      place.getMarker().addTo(window.mainmap);
                    } else {
                      place.getMarker().removeFrom(window.mainmap);
                    }
                  } else {
                    if (this.inactive) {
                      place.getMarker().addTo(window.mainmap);
                    } else {
                      place.getMarker().removeFrom(window.mainmap);
                    }
                  }
                } else {
                  place.getMarker().removeFrom(window.mainmap);
                }
              }
            } else {
              this.processPlacesOpenStreetMap()
            }
        },
        onCheckedAllCyclewaysChanged() {
            if (this.$options.cycleways) {
              for(const cycleway of this.$options.cycleways) {
                if (this.checkedAllCycleWays) {
                  if (cycleway.is_active) {
                    if (this.cyclewaysActive) {
                      cycleway.addTo(window.mainmap);
                    } else {
                      cycleway.removeFrom(window.mainmap);
                    }
                  } else {
                    if (this.cyclewaysInactive) {
                      cycleway.addTo(window.mainmap);
                    } else {
                      cycleway.removeFrom(window.mainmap);
                    }
                  }
                } else {
                  cycleway.removeFrom(window.mainmap);
                }
              }
            } else {
              this.processPlacesOpenStreetMap();
            }
        }
    },
    watch: {
        "checkedAllPoints": [{
            handler: "onCheckedAllChanged"
        }],
        "active": [{
            handler: "onCheckedAllChanged"
        }],
        "inactive": [{
            handler: "onCheckedAllChanged"
        }],
        "checkedAllCycleWays": [{
            handler: "onCheckedAllCyclewaysChanged"
        }],
        "cyclewaysActive": [{
            handler: "onCheckedAllCyclewaysChanged"
        }],
        "cyclewaysInactive": [{
            handler: "onCheckedAllCyclewaysChanged"
        }]
    }
})


</script>